/** Landings that need a person, as Overview's Needs you rows: parked ones, and failed ones from the last day. */
import type { LandingState } from '@orgus/protocol';
import type { NeedItem } from '../overview/needsYou.ts';
import { needsAttention } from './model.ts';

export function landingNeeds(state: LandingState | undefined, projectName: (id: string) => string | null, now: number): NeedItem[] {
  if (!state) return [];
  return needsAttention(state.landings, now).map((l) => ({
    key: `l:${l.id}`,
    // Parked: a decision only a person can make. Failed: shown like any failed pipeline item.
    kind: l.status === 'parked' ? 'landing' : 'pipeline',
    title: l.title,
    detail: l.problem ? `${l.problem.what} ${l.problem.next}` : l.step,
    where: [projectName(l.projectId), `to ${l.target}`].filter(Boolean).join(' '),
    at: l.endedAt ?? l.updatedAt,
    to: { path: `/pipelines/landing?queue=${encodeURIComponent(l.queueId)}&landing=${encodeURIComponent(l.id)}` },
    verb: l.status === 'parked' ? 'Resolve' : 'See why',
    subject: { kind: 'branch', id: l.source.branch },
  }));
}
